<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item prop="search" v-if="isSuper">
        <el-input size="small" v-model="formInline.appId" auto-complete="off" placeholder="输入appId"></el-input>
      </el-form-item>
      <el-form-item prop="search">
        <el-input size="small" v-model="formInline.extId" auto-complete="off" placeholder="输入extId"></el-input>
      </el-form-item>
      <el-form-item prop="search">
        <el-input size="small" v-model="formInline.name" auto-complete="off" placeholder="用户名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="handleSearch()">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column prop="appId" label="应用ID"></el-table-column>
      <el-table-column prop="extId" label="用户ID"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="age" label="年龄"></el-table-column>
      <el-table-column prop="gender" label="性别">
        <template slot-scope="scope">{{scope.row.gender==1?'男':scope.row.gender==2?'女':'未知'}}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="140"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="140"></el-table-column>

    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <el-dialog title="查看报告明细" :visible.sync="bfVisible" width="30%" @click="closeBfDialog">
      <div>
        报告ID：{{result.id}}
        <div style="margin-bottom:20px;">
          <h3 style="text-align: center">用户</h3>
          <p><strong>姓名：</strong>{{result.user.name}}</p>
          <p><strong>年龄：</strong>{{result.user.age}}</p>
          <p><strong>性别：</strong>{{result.user.gender==1?"男":"女"}}</p>
        </div>

        <div style="margin-bottom:20px;">
          <h3 style="text-align: center">体质结果</h3>
          <p><strong style="color:blue">{{result.resultTitle}}</strong></p>
          <p><strong>定义：</strong>{{result.detail.definition}}</p>
          <p><strong>常见不适：</strong>{{result.detail.discomfort}}</p>
          <p><strong>起因：</strong>{{result.detail.caution}}</p>
          <p><strong>穴位：</strong>{{result.detail.acupoint}}</p>
          <p><strong>饮食建议：</strong>{{result.detail.food}}</p>
          <p><strong>运动建议：</strong>{{result.detail.sport}}</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeBfDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    loadUser
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  import {getStore} from "../../utils/util";


  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        bfVisible: false,
        isSuper:parseInt(getStore('isSuper')),
        title: '添加',
        editForm: {
          deptId: '',
          deptName: '',
          deptNo: '',
          token: localStorage.getItem('logintoken')
        },
        result:{
          user:{},
          detail:{}
        },
        businessForm: {},
        // rules表单验证
        rules: {
          tutorName: [{
            required: true,
            message: '导师姓名必填',
            trigger: 'blur'
          }],
          mobile: [{
            required: true,
            message: '必填',
            trigger: 'blur'
          }],
          gender: [{
            required: true,
            message: '必填',
            trigger: 'blur'
          }],
          age: [{
            required: true,
            message: '必填',
            trigger: 'blur'
          }],
          academicTitleCode: [{
            required: true,
            message: '必填',
            trigger: 'blur'
          }],
          departmentCode: [{
            required: true,
            message: '必填',
            trigger: 'blur'
          }],
          introduction: [{
            required: true,
            message: '必填',
            trigger: 'blur'
          }]
        },
        formInline: {
          pageNum: 1,
          pageSize: 10,
          appId:'',
          extId:'',
          name:''
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        list: [],
        academicTitleList: [],
        levelList: [],
        jiaowuList: [],
        yiwuList: [],
        acceptTypeList: [],
        schoolList: []

      }
    },
    // 注册组件
    components: {
      Pagination
    },

    /**
     * 创建完毕
     */
    created() {
      this.getdata()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {

      loadAcademicTitle() {
        dictList({
          type: 'hospital_academic_title'
        })
          .then(res => {
            if (res.code != 0) {
              this.$message({
                type: 'error',
                message: res.msg
              })
            } else {
              this.academicTitleList = res.data.list
            }
          })
          .catch(err => {
            this.$message.error('职称加载失败，请稍后再试！')
          })
      },
      loadLevel() {
        dictList({
          type: 'tutor_business_level'
        })
          .then(res => {
            if (res.code != 0) {
              this.$message({
                type: 'error',
                message: res.msg
              })
            } else {
              this.levelList = res.data.list
            }
          })
          .catch(err => {
            this.$message.error('导师级别加载失败，请稍后再试！')
          })
      },
      loadUserList(type) {
        userSimpleList({
          role: type
        })
          .then(res => {
            if (res.code != 0) {
              this.$message({
                type: 'error',
                message: res.msg
              })
            } else {
              if (type == '教务') {
                this.jiaowuList = res.data.list
              } else if (type == '医务') {
                this.yiwuList = res.data.list
              }
            }
          })
          .catch(err => {
            this.$message.error('人员列表加载失败，请稍后再试！')
          })
      },
      loadAcceptType() {
        dictList({
          type: 'tutor_accept_type'
        })
          .then(res => {
            if (res.code != 0) {
              this.$message({
                type: 'error',
                message: res.msg
              })
            } else {
              this.acceptTypeList = res.data.list
            }
          })
          .catch(err => {
            this.$message.error('收徒类型加载失败，请稍后再试！')
          })
      },
      loadSchool() {
        schoolList({pageSize: 1000})
          .then(res => {
            if (res.code != 0) {
              this.$message({
                type: 'error',
                message: res.msg
              })
            } else {
              this.schoolList = res.data.list
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('加载校区失败，请稍后再试！')
          })
      },
      stateTrans(row, column, cellValue, index) {
        return cellValue == 1 ? '正常' : '禁用';
      },

      getdata(parameter) {
        this.loading = true
        loadUser(parameter)
          .then(res => {
            this.loading = false
            if (res.code !== '0000') {
              this.$message({
                type: 'error',
                message: res.msg
              })
            } else {
              this.listData = res.data.list
              // 分页赋值
              this.pageparm.currentPage = this.formInline.pageNum
              this.pageparm.pageSize = this.formInline.pageSize
              this.pageparm.total = res.data.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('列表加载失败，请稍后再试！')
          })
      },

      // 分页插件事件
      callFather(parm) {
        this.formInline.pageNum = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },

      //显示编辑界面
      handleEdit: function (index, row) {
        window.open(row.reportUrl)
      },
      handleSearch: function(index, row){
        this.getdata(this.formInline)
      },
      handleDelete: function (index, row) {
        this.$confirm('确定要删除【' + row.tutorName + '】吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            tutorDelete(row.id)
              .then(res => {
                if (res.code == 0) {
                  this.$message({
                    type: 'success',
                    message: res.msg
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'error',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('删除失败，请稍后再试！')
              })
          })
          .catch(() => {
            console.log('cancel delete..');
          })
      },
      handleDisable: function (index, row) {
        tutorDisable({
          id: row.id,
          state: row.state == 1 ? -1 : 1
        })
          .then(res => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('删除失败，请稍后再试！')
          })
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            tutorSaveUpdate(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.code == 0) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'error',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          } else {
            return false
          }
        })
      },
      submitBusinessForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            tutorBusinessSaveUpdate(this.businessForm)
              .then(res => {
                this.loading = false
                if (res.code == 0) {
                  this.bfVisible = false
                  this.getdata(this.formInline);
                  this.$message({
                    type: 'success',
                    message: '保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'error',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          } else {
            return false
          }
        })
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
      },
      closeBfDialog() {
        this.bfVisible = false;
      },

      handleAvatarSuccess(res, file) {
        if (res.code == 0) {
          this.editForm.avatarUrl = res.data.url;
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      },
      beforeAvatarUpload(file) {
        const formatOk = (file.type === 'image/jpeg' || file.type === 'image/png');
        const sizeLt1M = file.size / 1024 / 1024 < 1;

        if (!formatOk) {
          this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
        }
        if (!sizeLt1M) {
          this.$message.error('上传头像图片大小不能超过 1MB!');
        }
        return formatOk && sizeLt1M;
      },
      editBusiness(index, row) {
        this.bfVisible = true;
        this.result = row
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

  .el-form-item {
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/user/list.vue